module.exports = __webpack_public_path__ + "static/media/crdscij.624e9569.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdscij.png
// module id = 176
// module chunks = 0